"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppButtonRoundedPlain = exports.AppButton = exports.AutoPlayButton = exports.UploadDocumentImageButton = exports.RegenerateDocumentImageButton = exports.SourcesButton = exports.ShareButton = exports.ChatButton = exports.SourceButton = exports.UploadControl = exports.CategoryButton = void 0;
exports.NeutralButton = NeutralButton;
exports.PrimaryButton = PrimaryButton;
const jsx_runtime_1 = require("react/jsx-runtime");
const colors_1 = require("../../common/colors");
const constants_1 = require("../../common/constants");
const Button_1 = __importDefault(require("../ui-components/Button"));
const react_redux_1 = require("react-redux");
var CategoryButton_1 = require("./CategoryButton");
Object.defineProperty(exports, "CategoryButton", { enumerable: true, get: function () { return __importDefault(CategoryButton_1).default; } });
var UploadControl_1 = require("./UploadControl");
Object.defineProperty(exports, "UploadControl", { enumerable: true, get: function () { return __importDefault(UploadControl_1).default; } });
var SourceButton_1 = require("./SourceButton");
Object.defineProperty(exports, "SourceButton", { enumerable: true, get: function () { return __importDefault(SourceButton_1).default; } });
var ChatButton_1 = require("./ChatButton");
Object.defineProperty(exports, "ChatButton", { enumerable: true, get: function () { return __importDefault(ChatButton_1).default; } });
var ShareButton_1 = require("./ShareButton");
Object.defineProperty(exports, "ShareButton", { enumerable: true, get: function () { return __importDefault(ShareButton_1).default; } });
var SourcesButton_1 = require("./SourcesButton");
Object.defineProperty(exports, "SourcesButton", { enumerable: true, get: function () { return __importDefault(SourcesButton_1).default; } });
var RegenerateDocumentImageButton_1 = require("./RegenerateDocumentImageButton");
Object.defineProperty(exports, "RegenerateDocumentImageButton", { enumerable: true, get: function () { return __importDefault(RegenerateDocumentImageButton_1).default; } });
var UploadDocumentImageButton_1 = require("./UploadDocumentImageButton");
Object.defineProperty(exports, "UploadDocumentImageButton", { enumerable: true, get: function () { return __importDefault(UploadDocumentImageButton_1).default; } });
var AutoPlayButton_1 = require("./AutoPlayButton");
Object.defineProperty(exports, "AutoPlayButton", { enumerable: true, get: function () { return __importDefault(AutoPlayButton_1).default; } });
const AppButton = ({ children, ...rest }) => {
    const { selectedFontId } = (0, react_redux_1.useSelector)((state) => state.fontSettings);
    const selectedFont = constants_1.AVAILABLE_FONTS.find(font => font.id === selectedFontId);
    const fontFamily = selectedFont?.fontFamily;
    return (0, jsx_runtime_1.jsx)(Button_1.default, { ...rest, _text: { fontFamily }, children: children });
};
exports.AppButton = AppButton;
const AppButtonRoundedPlain = ({ children, variant, ...rest }) => {
    const { selectedFontId } = (0, react_redux_1.useSelector)((state) => state.fontSettings);
    const selectedFont = constants_1.AVAILABLE_FONTS.find(font => font.id === selectedFontId);
    const fontFamily = selectedFont?.fontFamily;
    return ((0, jsx_runtime_1.jsx)(exports.AppButton, { variant: "outline", borderColor: colors_1.Colors.DARK_500, rounded: 30, _text: { color: rest.color === "solid" ? colors_1.Colors.white : colors_1.Colors.PRIMARY_BLUE, fontFamily }, backgroundColor: variant === "solid" ? colors_1.Colors.PRIMARY_300 : colors_1.Colors.DARK_700, _pressed: {
            backgroundColor: colors_1.Colors.DARK_700
        }, ...rest, children: children }));
};
exports.AppButtonRoundedPlain = AppButtonRoundedPlain;
function NeutralButton({ fontWeight, style, children, ...rest }) {
    const { selectedFontId } = (0, react_redux_1.useSelector)((state) => state.fontSettings);
    const selectedFont = constants_1.AVAILABLE_FONTS.find(font => font.id === selectedFontId);
    const fontFamily = selectedFont?.fontFamily;
    return ((0, jsx_runtime_1.jsx)(Button_1.default, { variant: "outline", style: [{
                paddingHorizontal: 16,
                paddingVertical: 12,
                borderColor: colors_1.Colors.DARK_500,
                borderRadius: 26
            }, style], _text: {
            color: colors_1.Colors.PRIMARY_200,
            fontSize: 16,
            fontWeight: fontWeight ?? 500,
            lineHeight: 20,
            fontFamily
        }, _pressed: {
            backgroundColor: colors_1.Colors.PRIMARY_700,
            borderColor: colors_1.Colors.PRIMARY_200
        }, _hover: {
            backgroundColor: "contrastThreshold",
        }, ...rest, children: children }));
}
function PrimaryButton({ textProps, children, ...rest }) {
    const { selectedFontId } = (0, react_redux_1.useSelector)((state) => state.fontSettings);
    const selectedFont = constants_1.AVAILABLE_FONTS.find(font => font.id === selectedFontId);
    const fontFamily = selectedFont?.fontFamily;
    return ((0, jsx_runtime_1.jsx)(Button_1.default, { variant: "solid", backgroundColor: colors_1.Colors.PRIMARY_300, paddingX: 6, paddingTop: 3, paddingBottom: 3, borderRadius: 26, _text: {
            color: colors_1.Colors.DARK_700,
            fontSize: 16,
            fontWeight: 500,
            lineHeight: 20,
            fontFamily,
            ...textProps
        }, ...rest, children: children }));
}
exports.default = exports.AppButton;
